export default {
    path: "/whatsapp",
    name: "WhatsApp",
    meta: {
        title: "whatsapp.title",
    },
    component: () => import("../../views/WhatsApp/index.vue"),
    redirect: "/whatsapp/waloading",
    children: [
        {
            path: "waloading",
            name: "WALoading",
            meta: {
                title: "whatsapp.title",
            },
            component: () => import("../../views/WhatsApp/WALoading.vue"),
        },
        {
            path: "walogin",
            name: "WALogin",
            meta: {
                title: "whatsapp.title",
            },
            component: () => import("../../views/WhatsApp/Login.vue"),
        },
        {
            path: "wahome",
            name: "WAHome",
            meta: {
                title: "whatsapp.title",
            },
            component: () => import("../../views/WhatsApp/Home.vue"),
        },
    ],
};
